import { Artist } from "@/types/defs/artist";
import { getArtistSweetSpot } from "@/utils/audio/quality/getArtistSweetSpot";

// The AI backend's `sweetspot` hint is either a degenerate range {low: midi, high: midi} at the artist's designated sweet spot, or the artist's full vocal range when no sweet spot is designated.
export const getArtistSweetSpotRange = (
  artist: Artist
): { low: number; high: number } => {
  const sweetSpotMidi = getArtistSweetSpot(artist);
  if (sweetSpotMidi !== null) {
    return { low: sweetSpotMidi, high: sweetSpotMidi };
  }
  return artist.filters.pitchRange.specific;
};
